import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiGrid } from 'react-icons/fi';
import styles from './DashboardEmptyState.module.scss';

type Props = {
	onAddClick: () => void;
	totalWidgets: number;
	// Override do label do botão primário (ex.: o ativo usa "Widgets" p/ coerência com o header).
	primaryLabel?: string;
	// Ação secundária opcional, à ESQUERDA do primário (ex.: "Gestão de disposição" no ativo).
	secondaryAction?: { label: string; onClick: () => void };
};

const DashboardEmptyState = ({ onAddClick, totalWidgets, primaryLabel, secondaryAction }: Props) => {
	const { t } = useTranslation();

	return (
		<div className={styles.container}>
			<div className={styles.ghosts}>
				<div className={styles.ghostCard} style={{ height: 60 }} />
				<div className={styles.ghostCard} style={{ height: 80 }} />
				<div className={styles.ghostCard} style={{ height: 60 }} />
				<div className={styles.ghostCard} style={{ height: 70 }} />
				<div className={styles.ghostCard} style={{ height: 80 }} />
				<div className={styles.ghostCard} style={{ height: 60 }} />
				<div className={styles.ghostCard} style={{ height: 70 }} />
				<div className={styles.ghostCard} style={{ height: 60 }} />
			</div>
			<div className={styles.icon}>
				<FiGrid />
			</div>
			<div className={styles.title}>{t('dashboard.empty.title')}</div>
			<p
				className={styles.description}
				dangerouslySetInnerHTML={{
					__html: t('dashboard.empty.description', { count: totalWidgets }) as string,
				}}
			/>
			<div className={styles.actions}>
				{secondaryAction && (
					<button className={styles.secondaryButton} onClick={secondaryAction.onClick}>
						{secondaryAction.label}
					</button>
				)}
				<button className={styles.addButton} onClick={onAddClick}>
					{primaryLabel ?? `+ ${t('dashboard.empty.add_button') as string}`}
				</button>
			</div>
		</div>
	);
};

export default DashboardEmptyState;
